import React, { useEffect, useState } from 'react';
import * as api from '../services/api';
import Loader from '../../components/Loader';
import styles from '../informationManager/manager.module.css';
import back from '../../assets/icons/back.svg';
import add from '../../assets/icons/add.svg';
import deleteBin from '../../assets/icons/delete.svg';
import InsertBar from '../../components/InsertBar';
import ReadOnlyBar from '../../components/ReadOnlyBar';
import ReadOnlyBarSmall from '../../components/ReadOnlyBarSmall';
import CustomizedModal from '../../components/modal/CustomizedModal';
import { Box, Button, Input, MenuItem, Select, TextField, Stepper, Step, StepLabel, InputAdornment, IconButton, FormControl, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import { useNavigate, useLocation } from "react-router-dom";
import CloseIcon from '@mui/icons-material/Close';

function AddAssessment() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [part, setPart] = useState(1);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showDeleteImageModal, setShowDeleteImageModal] = useState(false);
  const [showDeleteCriteriaModal, setShowDeleteCriteriaModal] = useState(false);
  const [criteriaToDelete, setCriteriaToDelete] = useState({ formId: null, quizIndex: null });
  const [showDeleteQuizModal, setShowDeleteQuizModal] = useState(false);
  const [quizToDelete, setQuizToDelete] = useState({ formId: null, criteriaIndex: null });
  const [errorMessage, setErrorMessage] = useState(null);
  const [activeStep, setActiveStep] = useState(0);
  const steps = ['1', '2', '3'];
  const [category, setCategory] = useState([]);
  const quizType = ['หลายตัวเลือก', 'คำตอบสั้น ๆ (ไม่มีการแปลผล)', 'สเกลเชิงเส้น (ระดับ)']

  const location = useLocation();

  const [data, setData] = useState({
    title: "",
    image: "",
    remark: "",
    part: "",
    forms: []
  })

  const changeStep = () => {
    if (activeStep === 0) {
      if (!data['title']) {
        return handleError('กรุณาใส่ชื่อแบบประเมิน')
      }
      if (!data['image']) {
        return handleError('กรุณาใส่รูป')
      }
      if (!data['remark']) {
        return handleError('กรุณาใส่รายละเอียดแบบประเมิน')
      }
      if (!data['part'] || data['part'] < 1) {
        return handleError('กรุณาใส่เลขจำนวนพาร์ทให้ถูกต้อง โดยสามารถเลือกได้ตั้งแต่ 1 พาร์ทเป็นต้นไป')
      }
      createForms()
      // setActiveStep( activeStep + 1 )
    } else if (activeStep === 1) {
      if (!data.forms || !Array.isArray(data.forms)) {
        return handleError('ข้อมูลฟอร์มไม่ถูกต้อง');
      }

      for (const form of data.forms) {

        if (!form.topic) return handleError('กรุณาใส่ชื่อหัวข้อ');
        if (!form.topic_detail) return handleError('กรุณาใส่คำชี้แจง');
        if (!form.forms || !form.forms.length) return handleError('กรุณาเพิ่มข้อแบบทดสอบอย่างน้อย 1 ข้อ');

        let forms = form.forms;

        for (const q of forms) {
          if (!q.question) return handleError('กรุณาใส่คำถาม');

          if (["หลายตัวเลือก", "สเกลเชิงเส้น (ระดับ)"].includes(q.question_type)) {
            if (!q.answer || !q.answer.length) {
              return handleError('เพิ่มคำตอบอย่างน้อย 1 ตัวเลือก');
            }

            // if (q.answer.some(a => !a.name || !a.value)) {
            //   return handleError('กรุณาตรวจสอบแบบทดสอบ');
            // }

            if (q.question_type === "หลายตัวเลือก") {
              for (let ans of q.answer) {
                const toValue = ans.to;

                // Check if it's a number and if it equals forms.length
                if (Number(toValue) > forms.length) {
                  // console.log(toValue)
                  return handleError(`พบคำถามที่มีการข้ามไปยังข้อที่ไม่ถูกต้อง`);
                }
              }
            }
          }
        }
      }

    }
    setActiveStep(activeStep + 1)
  };

  const createForms = () => {
    let prevLength = data.forms.length
    let newFormNum = data.part - data.forms.length;
    if (newFormNum > 0) {
      const newCategories = [...category];
      for (let i = 1; i <= newFormNum; i++) {
        let form = {
          evaluation_code: data.code,
          line_number: `${prevLength + i}`,
          topic: "",
          topic_detail: "",
          forms: []
        }
        data.forms.push(form);
        newCategories.push("");
      }
      setCategory(newCategories);
    } else if (newFormNum < 0) {
      data.forms = data.forms.slice(0, part);
    }
  }

  const addQuiz = (id, quiz_type) => {
    const updatedData = { ...data }
    let forms = updatedData.forms[id].forms;
    if (!quiz_type) { handleError('กรุณาเลือกประเภทแบบทดสอบ') }
    else {
      let quiz = {
        question_number: forms.length + 1,
        question: "",
        question_type: "",
        answer: []
      }
      if (quiz_type === 'หลายตัวเลือก') {
        quiz.question_type = "หลายตัวเลือก"
        quiz.answer = [
          {
            "name": "",
            "value": "",
            "to": "null"
          },
          {
            "name": "",
            "value": "",
            "to": "null"
          },
          {
            "name": "",
            "value": "",
            "to": "null"
          }
        ]
      } else if (quiz_type === 'คำตอบสั้น ๆ (ไม่มีการแปลผล)') {
        quiz.question_type = "คำตอบสั้น ๆ (ไม่มีการแปลผล)"
      } else {
        quiz.question_type = "สเกลเชิงเส้น (ระดับ)"
        quiz.answer = [
          {
            "name": "",
            "value": ""
          },
          {
            "name": "",
            "value": ""
          }
        ]
      }

      forms.push(quiz);
      updatedData.forms[id].forms = forms;
      setData(updatedData)
      // Update category state
      const newCategories = [...category];
      newCategories[id] = quiz_type;
      setCategory(newCategories);
    }
  }

  const addCriteria = (id) => {
    const newCriteria = {
      score_from: "",
      score_to: "",
      recommend: "", // ข้อความแปลผล
      recommend_detail: "" // คำแนะนำ/คำอธิบายเพิ่มเติม
    };

    const updatedData = { ...data };
    if (!Array.isArray(updatedData.forms[id].interpret)) {
      updatedData.forms[id].interpret = [];
    }
    updatedData.forms[id].interpret.push(newCriteria);
    setData(updatedData);
  };

  const removeQuiz = (formId, quizIndex) => {
    setQuizToDelete({ formId, quizIndex });
    setShowDeleteQuizModal(true);
  };

  const confirmRemoveQuiz = () => {
    const { formId, quizIndex } = quizToDelete;
    let form_length = data.forms[formId].forms.length;

    if (
      data.forms[formId] &&
      quizIndex >= 0 &&
      quizIndex < form_length
    ) {
      // Remove the quiz at the specified index
      data.forms[formId].forms.splice(quizIndex, 1);

      // If `data` is part of a state, update it:
      // setData({ ...data });

      form_length = data.forms[formId].forms.length;

      for (let i = quizIndex; i < form_length; i++) {
        // update data at index i
        data.forms[formId].forms[i].question_number = i + 1;
      }
      setData({ ...data });

    } else {
      handleError("Invalid formId or quizIndex");
    }
    setShowDeleteQuizModal(false);
  };

  const removeCriteria = (formId, criteriaIndex) => {
    setCriteriaToDelete({ formId, criteriaIndex });
    setShowDeleteCriteriaModal(true);
  };

  const confirmRemoveCriteria = () => {
    const { formId, criteriaIndex } = criteriaToDelete;
    if (
      data.forms[formId] &&
      Array.isArray(data.forms[formId].interpret) &&
      criteriaIndex >= 0 &&
      criteriaIndex < data.forms[formId].interpret.length
    ) {
      // Remove the criteria at the specified index
      data.forms[formId].interpret.splice(criteriaIndex, 1);

      // If `data` is part of a state, update it:
      setData({ ...data });
    } else {
      handleError("Invalid formId or criteriaIndex");
    }
    setShowDeleteCriteriaModal(false);
  };


  const handlePrevious = () => {
    if (data['title'] || data['remark']) {
      setShowCancelModal(true);
    } else {
      navigate('/manageAssessment');
    }
  };

  const confirmCancelChanges = () => {
    setShowCancelModal(false);
    navigate('/manageAssessment');
  };

  const confirmDelete = async () => {
    setShowCancelModal(false);
    navigate('/manageAssessment');
  };

  const handleError = (msg) => {
    setErrorMessage(msg);
    setShowUpdateModal(false);
  };

  const handleUpdate = async () => {
    if (!data['title']) {
      handleError("กรุณากรอกชื่อแบบประเมิน");
      return;
    }
    if (!data['remark']) {
      handleError("กรุณากรอกรายละเอียด");
      return;
    }

    // Ensure all quiz_answer values are set to 0 if not given
    const updatedData = { ...data };
    updatedData.forms.forEach(form => {
      form.forms.forEach(quiz => {
        quiz.answer.forEach(answer => {
          if (!answer.value) {
            answer.value = 0;
          }
        });
      });
    });

    // Ensure all criteria is filled or else will be deleted
    updatedData.forms.forEach(form => {
      if (!Array.isArray(form.interpret)) {
        form.interpret = [];
      }
      form.interpret = form.interpret.filter(cri => {
        return cri.score_from || cri.score_to || cri.recommend || cri.recommend_detail;
      });
    });

    setShowUpdateModal(true);
  };

  const confirmedUpdate = async () => {
    setLoading(true);
    let body = {};
    body.evaluation_detail = data['remark'];
    body.evaluation_name = data['title'];
    body.evaluation_image = data['image'];
    body.evaluation_part_total = data['part'];
    body.evaluation_section = data['forms']
    body.updated_date = new Date().toISOString();
    body.updated_user = JSON.parse(localStorage.getItem('userData'))?.uid;
    const res = await api.newFormEvaluation(body);
    setLoading(false);

    console.log(body);


    if (res) {
      if (res['data']['code'] === 200) {
        setShowUpdateModal(false);
        navigate('/manageAssessment')
      } else {
        handleError(res['data']['message']);
      }
    } else {
      handleError("ไม่ตอบสนอง");
    }

  };

  // const uploadImage = async (file) => {
  //   const res = await api.uploadFile2('assessment',file);
  //   return res.data.data.url;
  // }

  const handleAddImages = async (event) => {
    // const files = event.target.files; 
    // if (files.length > 0) {
    //   try {
    //     setLoading(true);
    //     const file = event.target.files && event.target.files[0];
    //     let formData = new FormData()
    //     formData.append('file', file)
    //     const uploadedImageUrl = await uploadImage(formData);
    //     setData({...data, 'image':uploadedImageUrl})
    //   } catch (error) {
    //     handleError("อัพโหลดรูปไม่สำเร็จ ลองใหม่อีกครั้ง");
    //   } finally {
    //     setLoading(false);
    //     event.target.value = null;
    //   }
    // }
    const file = event.target.files && event.target.files[0];
    if (!file) return;

    let formData = new FormData()
    formData.append('file', file)
    formData.append('file_path', `/evaluation`)
    formData.append('file_source', 'evaluation')
    formData.append('file_name', file.name)

    setLoading(true)
    let res = await api.uploadFileImage('evaluation', formData)
    setLoading(false)
    if (!res) return alert('ไม่ตอบสนอง')

    const code = res['code']
    if (code === 200) {
      setData({ ...data, 'image': res['data']['file_api_url'] })
    } else if (code === 403) {
      alert('รูปประกอบแบบประเมิน รองรับไฟล์เฉพาะ .jpeg, .jpg, .png เท่านั้น')
    } else {
      console.log('error', res)
      alert('ไม่ตอบสนอง')
    }
  };

  const handleChange = (type, index, e) => {

    if (type === 'category') {
      const newCategories = [...category];
      newCategories[index] = e.target.value;
      setCategory(newCategories);
      //setData quiztype 
      // setErrorMessage('')
    }
  }


  const handleDeleteImage = () => {
    setData({ ...data, 'image': "" });
    handleCloseDeleteImageModal();
  };

  const handleDeleteCriteria = () => {
    setData({ ...data, 'image': "" });
    handleCloseDeleteImageModal();
  };

  const handleRadioChange = (index, value) => {
    setData(prevData => {
      const updatedForms = [...prevData.forms];
      if (value === "มีเกณฑ์แปลผล") {
        updatedForms[index].interpret = {
          formula: "",
          interpret_name: "",
          recommend: "",
          recommend_detail: "",
          score_from: "0",
          score_to: "0"
        };
      } else {
        if (updatedForms[index].interpret.length != 0 && window.confirm("ยืนยันการลบเงื่อนไขทั้งหมดในส่วนนี้?")) {
          updatedForms[index].interpret = [];
        }
      }
      return { ...prevData, forms: updatedForms };
    });
  };

  const handleCloseErrorModal = () => setErrorMessage(null);
  const handleCloseCancelModal = () => setShowCancelModal(false);
  const handleCloseDeleteModal = () => setShowDeleteModal(false)
  const handleCloseUpdateModal = () => setShowUpdateModal(false)
  const handleCloseDeleteImageModal = () => setShowDeleteImageModal(false)
  const handleCloseDeleteCriteriaModal = () => setShowDeleteCriteriaModal(false)
  const handleCloseDeleteQuizModal = () => setShowDeleteQuizModal(false)

  return (
    <>
      <Loader loading={loading} />
      {/* Update Modal */}
      {showUpdateModal && (
        <CustomizedModal
          onClose={handleCloseUpdateModal}
          apiCall={confirmedUpdate}
          confirmMessage={`ยืนยันที่จะเพิ่มข้อมูล`}
          confirmButtonText={`ยืนยัน`}
        />
      )}

      {/* Error Modal */}
      {errorMessage && (
        <CustomizedModal
          onClose={handleCloseErrorModal}
          confirmMessage={errorMessage}
          apiCall={handleCloseErrorModal}
          confirmButtonText="ตกลง"
        />
      )}

      {/* Cancel Modal */}
      {showCancelModal && (
        <CustomizedModal
          onClose={handleCloseCancelModal}
          apiCall={confirmCancelChanges}
          confirmMessage="ยกเลิกการเปลี่ยนแปลง?"
          confirmButtonText="ตกลง"
        />
      )}

      {/* Delete Image */}
      {showDeleteImageModal && (
        <CustomizedModal
          onClose={handleCloseDeleteImageModal}
          apiCall={handleDeleteImage}
          confirmMessage={"ยืนยันการลบรูปนี้"}
          confirmButtonText={"ตกลง"}
        />
      )}

      {/* Delete Criteria */}
      {showDeleteCriteriaModal && (
        <CustomizedModal
          onClose={handleCloseDeleteCriteriaModal}
          apiCall={confirmRemoveCriteria}
          confirmMessage={"ยืนยันการลบเงื่อนไขนี้"}
          confirmButtonText={"ตกลง"}
        />
      )}

      {/* Delete Quiz */}
      {showDeleteQuizModal && (
        <CustomizedModal
          onClose={handleCloseDeleteQuizModal}
          apiCall={confirmRemoveQuiz}
          confirmMessage={"ยืนยันการลบคำถามข้อนี้"}
          confirmButtonText={"ตกลง"}
        />
      )}

      {/* Back Button */}
      <Box className={`${styles.bodyText} ${styles.inlineFlex}`} onClick={handlePrevious}>
        <img src={back} alt="Previous" className={styles.directIcon} />
        กลับไป จัดการแบบประเมิน
      </Box>

      {/* Page Header */}
      <Box className={styles.head1Text}>เพิ่มแบบประเมิน</Box>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: '30px',
          marginBottom: '40px'
        }}
      >
        <Stepper
          alternativeLabel
          activeStep={activeStep}
          sx={{
            width: '380px',
            '& .MuiStepConnector-line': {
              borderStyle: 'dashed',
              borderWidth: 1,
              marginLeft: '18px',
              marginRight: '18px'
            },
            '& .MuiStepLabel-root .MuiStepIcon-root': {
              color: 'transparent',
              border: '0.5px solid #478F96',
              borderRadius: '20px',
              scale: '220%',
            },
            '& .MuiStepLabel-root .MuiStepIcon-text': {
              fill: '#478F96',
              fontSize: '8px',
              fontWeight: 600
            },
            '& .MuiStepLabel-root .Mui-active': {
              color: '#478F96',
              border: '0px',
            },
            '& .MuiStepLabel-root .Mui-active .MuiStepIcon-text': {
              fill: '#ffffff'
            },
            '& .MuiStepLabel-label': {
              display: 'none',
            },
            '& .MuiStepLabel-root .Mui-completed': {
              fill: '#478F96'
            },
          }}
        >
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
      </Box>

      {/* Main Form Container */}
      {(() => {
        switch (activeStep) {
          case 0:
            return (
              <Box sx={{ border: '1.4px solid #478F96', borderRadius: 2, padding: 4, marginTop: '18px' }}>

                {/* Title Section */}
                <Box className={styles.head2Text}>ชื่อแบบประเมิน<span style={{ color: 'red' }}>*</span></Box>
                <InsertBar
                  currentValue={data['title']}
                  setNewValue={(event) => { setData({ ...data, 'title': event }); }}
                  placeholder="ชื่อแบบประเมิน"
                />

                {/* Images Section */}
                <Box className={styles.head2Text} sx={{ marginTop: 1, display: 'flex', alignItems: 'center' }}>
                  รูปภาพประกอบ <span style={{ color: 'red' }}>*</span>
                  {!data['image'] ?
                    <img
                      src={add}
                      alt="Add"
                      onClick={() => document.getElementById('file-input').click()}
                      className={styles.modifyIcon}
                      style={{ marginLeft: '8px' }}
                    />
                    : null}
                  <input
                    id="file-input"
                    type="file"
                    accept=".jpg,.jpeg,.png"
                    onChange={handleAddImages}
                    sx={{ display: 'none' }}
                  />
                </Box>

                {/* Display Images Section */}
                <Box
                  sx={{
                    marginBottom: 2,
                    textAlign: 'center',
                    border: '1.4px solid #478F96',
                    borderRadius: 2,
                    height: '300px',
                    padding: 3,
                    overflow: 'hidden',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    position: 'relative',
                  }}
                >
                  {data['image'] ? (
                    <>
                      {/* Delete Image Button */}
                      <img
                        src={deleteBin}
                        alt="Delete"
                        onClick={() => setShowDeleteImageModal(true)}
                        className={styles.modifyIcon}
                        style={{
                          position: 'absolute',
                          top: '5px',
                          right: '5px',
                          zIndex: 1,
                        }}
                      />
                      <Box sx={{ position: 'relative', height: '100%' }}>
                        <img
                          src={data['image']}
                          alt="Selected"
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'contain',
                          }}
                        />
                      </Box>
                    </>
                  ) : (
                    <p>ไม่มีรูปภาพ</p>
                  )}
                </Box>

                {/* Remark */}
                <Box className={styles.head2Text} sx={{ marginTop: 1 }}>
                  รายละเอียดแบบประเมิน<span style={{ color: 'red' }}>*</span>
                </Box>
                <Box sx={{ margin: "20px auto" }}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    value={data['remark']}
                    onChange={(event) => { setData({ ...data, 'remark': event.target.value }) }}
                    placeholder="อธิบายที่นี่..."
                    multiline
                    rows={6}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        border: '1.4px solid #478F96',
                        borderRadius: 2,
                        fontSize: '14px',
                      },
                      '& .MuiOutlinedInput-notchedOutline': {
                        border: 'none', // Removes the default Material-UI border
                      },
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        border: '1.4px solid #478F96',
                      },
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        border: '1.4px solid #478F96',
                      },
                    }}
                  />
                </Box>

                {/* Tags Section */}
                <Box className={styles.head2Text} sx={{ marginTop: 1 }}>
                  จำนวนพาร์ท<span style={{ color: 'red' }}>*</span> <span style={{ color: '#9D9B9B' }}>(ต้องการแบ่งแบบสอบถามเป็นกี่ส่วน)</span>
                </Box>
                <InsertBar
                  currentValue={data['part']}
                  setNewValue={(newPart) => {
                    // Allow only numeric input
                    if (/^\d*$/.test(newPart)) {
                      setData({ ...data, part: newPart });
                    }
                  }}
                  placeholder="จำนวนพาร์ท (ขั้นต่ำ 1 พาร์ท)"
                />
              </Box>
            )
          case 1:
            return (
              <>
                {data["forms"].map((form, index) => (
                  <Box sx={{ border: '1.4px solid #478F96', borderRadius: 2, padding: 4, marginTop: '18px' }} key={index}>
                    <Box sx={{ textDecoration: 'underline', fontWeight: 600, color: '#478F96' }}>ส่วนที่ {index + 1}</Box>
                    <Box className={styles.head2Text} sx={{ marginTop: 1 }}>
                      ชื่อหัวข้อ<span style={{ color: 'red' }}>*</span>
                    </Box>
                    <InsertBar
                      currentValue={form.topic}
                      setNewValue={(newPart) => {
                        const updatedForms = data.forms.map((f, i) =>
                          i === index ? { ...f, topic: newPart } : f
                        );
                        setData({ ...data, forms: updatedForms });
                      }}
                      placeholder="ชื่อหัวข้อ"
                    />

                    <Box className={styles.head2Text} sx={{ marginTop: 1 }}>
                      คำชี้แจง<span style={{ color: 'red' }}>*</span>
                    </Box>
                    <TextField
                      variant="outlined"
                      fullWidth
                      value={form.topic_detail}
                      onChange={(e) => {
                        const updatedForms = data.forms.map((f, i) =>
                          i === index ? { ...f, topic_detail: e.target.value } : f
                        );
                        setData({ ...data, forms: updatedForms });
                      }}
                      placeholder="พิมพ์คำชี้แจงที่นี่"
                      multiline
                      rows={4}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          border: '1.4px solid #478F96',
                          borderRadius: 2,
                          fontSize: '14px',
                        },
                        '& .MuiOutlinedInput-input': {
                          fontSize: '14px',
                        },
                        '& .MuiOutlinedInput-notchedOutline': {
                          border: 'none', // Removes the default Material-UI border
                        },
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          border: '1.4px solid #478F96',
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          border: '1.4px solid #478F96',
                        },
                      }}
                    />

                    <Box sx={{ display: 'flex', gap: '20px', marginTop: 2, alignItems: 'center' }}>
                      <Box className={styles.head2Text} sx={{ marginTop: 1 }}>
                        เลือกประเภท
                      </Box>
                      <Select
                        size="small"
                        value={category[index] || "null"}
                        onChange={(e) => { handleChange('category', index, e) }}
                        sx={{
                          backgroundColor: '#C8EBEB',
                          border: 'none',
                          '.MuiOutlinedInput-notchedOutline': {
                            borderColor: '#C8EBEB',
                          },
                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#C8EBEB',
                          },
                          '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#C8EBEB',
                          },
                          fontWeight: 600,
                          color: '#478F96',
                          fontSize: '14px',
                          width: '20%',
                          height: '50px'
                          //  // Ensure the Select fills the Box width
                        }}
                      >
                        <MenuItem value="" disabled>
                          กรุณาเลือก
                        </MenuItem>
                        {quizType.map((d) => (
                          <MenuItem key={d} value={d}>
                            {d}
                          </MenuItem>
                        ))}
                      </Select>
                    </Box>

                    <Box className={styles.head2Text} sx={{ marginTop: 2, display: 'flex', alignItems: 'center' }}>
                      เพิ่มหัวข้อแบบทดสอบ
                      <img
                        src={add}
                        alt="Add"
                        onClick={() => addQuiz(index, category[index])}
                        className={styles.modifyIcon}
                        style={{ marginLeft: '8px' }}
                      />
                    </Box>

                    {form.forms.map((quiz, quizIndex) => {
                      switch (quiz.question_type) {
                        case 'หลายตัวเลือก':
                          return (
                            <MultipleChoiceField
                              key={quizIndex}
                              partName={quiz.question}
                              data={data}
                              setData={setData}
                              index={quizIndex}
                              formId={index}
                              removeQuiz={removeQuiz}
                              handleError={handleError}
                            />
                          )
                        case 'คำตอบสั้น ๆ (ไม่มีการแปลผล)':
                          return (
                            <ShortAnswerField
                              key={quizIndex}
                              partName={quiz.question}
                              data={data}
                              setData={setData}
                              index={quizIndex}
                              formId={index}
                              removeQuiz={removeQuiz}
                            />
                          )
                        case 'สเกลเชิงเส้น (ระดับ)':
                          return (
                            <RatioField
                              key={quizIndex}
                              partName={quiz.question}
                              data={data}
                              setData={setData}
                              index={quizIndex}
                              formId={index}
                              removeQuiz={removeQuiz}
                            />
                          )
                        default:
                          return (<Box key={quizIndex}>กรุณาเพิ่มแบบทดสอบ</Box>)
                      }
                    })}
                  </Box>
                ))}
              </>
            )
          case 2:
            return (
              <>
                {data.forms.map((form, index) => (
                  <Box sx={{ border: '1.4px solid #478F96', borderRadius: 2, padding: 4, marginTop: '18px' }}>
                    <Box sx={{ textDecoration: 'underline', fontWeight: 600, color: '#478F96' }}>ส่วนที่ {form.line_number}</Box>
                    <Box className={styles.head2Text} sx={{ marginTop: 1 }}>
                      ชื่อหัวข้อ
                    </Box>
                    <ReadOnlyBar
                      currentValue={form.topic}
                      placeholder="ชื่อหัวข้อ"
                    />
                    <Box className={styles.head2Text} sx={{ marginTop: 1, display: 'flex', alignItems: 'center' }}>
                      <span style={{ marginRight: 8 }}>ประเภท</span>
                      <ReadOnlyBarSmall
                        currentValue={category[index]}
                        placeholder="ชื่อประเภท"
                      />
                    </Box>
                    {/* radio button */}
                    {(category[index] == "สเกลเชิงเส้น (ระดับ)" || category[index] == "หลายตัวเลือก") && (
                      <>
                        <Box sx={{ marginTop: 2 }}>
                          <FormControl>
                            <RadioGroup
                              row
                              value={(form.interpret || []).length != 0 ? "มีเกณฑ์แปลผล" : "ไม่มีเกณฑ์แปลผล"}
                              onChange={(e) => handleRadioChange(index, e.target.value)}
                            >
                              <FormControlLabel value="มีเกณฑ์แปลผล" control={<Radio />} label={<span style={{ fontSize: '14px' }}>มีเกณฑ์แปลผล</span>} />
                              <FormControlLabel value="ไม่มีเกณฑ์แปลผล" control={<Radio />} label={<span style={{ fontSize: '14px' }}>ไม่มีเกณฑ์แปลผล</span>} />
                            </RadioGroup>
                          </FormControl>
                        </Box>

                        {(form.interpret || []).length != 0 && (
                          <>
                            <Box className={styles.head2Text} sx={{ marginTop: 2, display: 'flex', alignItems: 'center' }}>
                              เพิ่มเงื่อนไข
                              <img
                                src={add}
                                alt="Add"
                                onClick={() => addCriteria(index)}
                                className={styles.modifyIcon}
                                style={{ marginLeft: '8px' }}
                              />
                            </Box>
                            {form.interpret && Array.isArray(form.interpret) && form.interpret.map((cri, criIndex) => (
                              <RatioPoint
                                key={criIndex}
                                setData={setData}
                                formId={index}
                                criteria={cri}
                                criIndex={criIndex}
                                removeCriteria={removeCriteria}
                              />
                            ))}
                          </>
                        )}
                      </>
                    )}
                  </Box>

                ))}
              </>
            )
          default:
            return null
        }
      })()}

      {/* Save Button */}
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginRight: 4.3, gap: '10px', marginTop: 2 }}>
        <Button
          variant="outlined"
          disabled={activeStep === 0}
          sx={{
            backgroundColor: 'transparent',
            borderRadius: '10px',
            border: '1.4px solid #478F96',
            height: '50px',
            fontWeight: 600,
            width: '130px',
          }}
          onClick={() => { setActiveStep(activeStep - 1) }}
        >
          ย้อนกลับ
        </Button>
        <Button
          variant="contained"
          sx={{
            backgroundColor: '#478F96',
            borderRadius: '10px',
            height: '50px',
            fontWeight: 600,
            width: '130px',
          }}
          onClick={() => {
            if (activeStep !== 2) {
              changeStep();
            } else {
              handleUpdate();
            }
          }}
        >
          {activeStep !== 2 ? <p>ถัดไป</p> : <p>บันทึกข้อมูล</p>}
        </Button>
      </Box>
    </>
  );
}

export default AddAssessment;

function MultipleChoiceField({ partName, data, setData, formId, index, removeQuiz, handleError }) {
  return (
    <Box sx={{
      border: '1.4px solid #AEB4DD',
      borderRadius: 2,
      padding: 4,
      marginTop: '18px',
    }}>
      <Box sx={{
        marginTop: -1.5,
        display: 'flex',
        // alignItems: 'center',
        justifyContent: 'space-between',
      }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            flexDirection: 'row',
            marginTop: '23px',
            fontWeight: 600
          }}
        >ข้อที่ {index + 1}</Box>
        <Box width={'90%'}>
          <InsertBar
            currentValue={partName}
            setNewValue={(newPart) => {
              const updatedData = { ...data }; // Create a copy of the data object
              let quiz_topic = updatedData.forms[formId].forms;

              // Update quiz_topic with the new value
              updatedData.forms[formId].forms = quiz_topic.map((q, i) =>
                i === index ? { ...q, question: newPart } : q
              );

              setData(updatedData)
            }}
            placeholder="พิมพ์คำถามที่นี่"
          />
        </Box>
        <img
          src={deleteBin}
          alt="Delete"
          onClick={() => removeQuiz(formId, index)}
          className={styles.modifyIcon}
          style={{
            width: '20px',
            height: '20px',
            marginTop: '23px'
          }}
        />
      </Box>
      <AnswerField
        quizes={data.forms[formId].forms[index].answer}
        data={data}
        formId={formId}
        setData={setData}
        index={index}
        handleError={handleError}
      />


      <Box
        sx={{ paddingLeft: '55px', gap: '10px', paddingTop: '10px' }}
        display="flex"
        alignItems={'center'}
      >
        <Radio disabled />
        <Box width={'60%'}
          onClick={() => {
            const updatedData = { ...data }
            const prevQuiz = updatedData.forms[formId].forms[index].answer
            let form = {
              "name": "",
              "value": "",
              "to": "null"
            }

            prevQuiz.push(form)

            setData(updatedData)
          }}>
          <TextField
            variant="standard"
            placeholder='กดเพื่อเพิ่มตัวเลือก'
            value={Text}
            sx={{
              width: '100%',
              "& .MuiInputBase-input": {
                cursor: "pointer",
              },
            }}
            slotProps={{
              input: {
                readOnly: true,
              },
            }}
          />
        </Box>
      </Box>
    </Box>
  )
}

function AnswerField({ quizes, data, formId, index, setData, handleError }) {
  const score = [0, 1, 2, 3];

  return (
    <>
      {quizes.map((q, idx) => (
        <Box
          sx={{ paddingLeft: '55px', gap: '10px', paddingTop: '10px' }}
          display="flex"
          alignItems={'center'}
        >
          <Radio disabled />
          <Box width={'60%'}>
            <TextField
              variant="standard"
              placeholder='พิมพ์ตัวเลือกที่นี่'
              value={q.name}
              onChange={(e) => {
                const updatedData = { ...data }; // Create a copy of the data object
                let quiz_answer = updatedData.forms[formId].forms[index].answer;

                // Update quiz_topic with the new value
                updatedData.forms[formId].forms[index].answer = quiz_answer.map((q, i) =>
                  i === idx ? { ...q, name: e.target.value } : q
                );

                setData(updatedData)
              }}
              sx={{ width: '100%' }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => {
                        if (
                          data.forms[formId] &&
                          idx >= 0 &&
                          idx < data.forms[formId].forms[index].answer.length
                        ) {
                          // Remove the quiz at the specified index
                          data.forms[formId].forms[index].answer.splice(idx, 1);

                          // If `data` is part of a state, update it:
                          setData({ ...data });
                        } else {
                          handleError("Invalid formId or quizIndex");
                        }

                      }} // Clears the text when the icon is clicked
                      edge="end"
                    >
                      <CloseIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
          <Box sx={{ display: 'flex', gridGap: "10px" }}>
            <Select
              size="small"
              value={score.includes(q.value) ? q.value : "null"}
              onChange={(e) => {
                const updatedData = { ...data }; // Create a copy of the data object
                let quiz_answer = updatedData.forms[formId].forms[index].answer;

                // Update quiz_topic with the new value
                updatedData.forms[formId].forms[index].answer = quiz_answer.map((q, i) =>
                  i === idx ? { ...q, value: e.target.value } : q
                );

                setData(updatedData)
              }}
              sx={{
                backgroundColor: '#C8EBEB',
                border: 'none',
                '.MuiOutlinedInput-notchedOutline': {
                  borderColor: '#C8EBEB',
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#C8EBEB',
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#C8EBEB',
                },
                fontWeight: 600,
                color: '#478F96',
                fontSize: '14px',
                height: '50px',
                width: '150px',
              }}
            >
              <MenuItem value="null" disabled>
                เลือกคะแนน
              </MenuItem>
              {score.map((d) => (
                <MenuItem key={d} value={d}>
                  {d} คะแนน
                </MenuItem>
              ))}
            </Select>
            {q.to <= data.forms[formId].forms.length || q.to === "null" || q.to === "nextSec" ?
              <Select
                size="small"
                value={q.to}
                onChange={(e) => {
                  const updatedData = { ...data }; // Create a copy of the data object
                  let quiz_answer = updatedData.forms[formId].forms[index].answer;

                  // Update quiz_topic with the new value
                  updatedData.forms[formId].forms[index].answer = quiz_answer.map((q, i) =>
                    i === idx ? { ...q, to: e.target.value } : q
                  );

                  setData(updatedData)
                }}
                sx={{
                  backgroundColor: '#C8EBEB',
                  border: 'none',
                  '.MuiOutlinedInput-notchedOutline': {
                    borderColor: '#C8EBEB',
                  },
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#C8EBEB',
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#C8EBEB',
                  },
                  fontWeight: 600,
                  color: '#478F96',
                  fontSize: '14px',
                  height: '50px',
                  width: '150px',
                }}
              >
                <MenuItem value="null">
                  ข้ามไปที่
                </MenuItem>
                {data.forms[formId].forms
                  // .filter((d) => d !== index)
                  .map((d) => (
                    d.question_type === "หลายตัวเลือก" && d.question_number > index + 1 ?
                      <MenuItem key={d.question_number} value={d.question_number}>
                        ข้อที่ {d.question_number}
                      </MenuItem>
                      : <MenuItem key={d.question_number} value={d.question_number} disabled>
                        ข้อที่ {d.question_number}
                      </MenuItem>
                  ))}
                <MenuItem value="nextSec">
                  ข้ามไปส่วนถัดไป
                </MenuItem>
              </Select>
              :
              <FormControl error>
                <Select
                  size="small"
                  value={q.to}
                  onChange={(e) => {
                    const updatedData = { ...data }; // Create a copy of the data object
                    let quiz_answer = updatedData.forms[formId].forms[index].answer;

                    // Update quiz_topic with the new value
                    updatedData.forms[formId].forms[index].answer = quiz_answer.map((q, i) =>
                      i === idx ? { ...q, to: e.target.value } : q
                    );

                    setData(updatedData)
                  }}
                  sx={{
                    backgroundColor: '#C8EBEB',
                    border: 'none',
                    '.MuiOutlinedInput-notchedOutline': {
                      borderColor: '#C8EBEB',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#C8EBEB',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#C8EBEB',
                    },
                    fontWeight: 600,
                    color: '#478F96',
                    fontSize: '14px',
                    height: '50px',
                    width: '150px',
                  }}
                >
                  <MenuItem value="null" >
                    ข้ามไปที่
                  </MenuItem>
                  {data.forms[formId].forms
                    // .filter((d) => d !== index)
                    .map((d) => (
                      <MenuItem key={d.question_number} value={d.question_number}>
                        ข้อที่ {d.question_number}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            }
          </Box>
        </Box>
      ))}
    </>
  );
}

function ShortAnswerField({ data, setData, formId, partName, index, removeQuiz }) {
  return (
    <Box sx={{
      border: '1.4px solid #AEB4DD',
      borderRadius: 2,
      padding: 4,
      marginTop: '18px',
    }}>
      <Box sx={{
        marginTop: -1.5,
        display: 'flex',
        // alignItems: 'center',
        justifyContent: 'space-between',
      }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            flexDirection: 'row',
            marginTop: '23px',
            fontWeight: 600
          }}
        >ข้อที่ {index + 1}</Box>
        <Box width={'90%'}>
          <InsertBar
            currentValue={partName}
            setNewValue={(newPart) => {
              const updatedData = { ...data }; // Create a copy of the data object
              let quiz_topic = updatedData.forms[formId].forms;

              // Update quiz_topic with the new value
              updatedData.forms[formId].forms = quiz_topic.map((q, i) =>
                i === index ? { ...q, question: newPart } : q
              );

              setData(updatedData)
            }}
            placeholder="พิมพ์คำถามที่นี่"
          />
          <Box
            sx={{ color: "#9D9B9B" }}>
            ผู้ทำแบบประเมินจะพิมพ์คำตอบด้วยตนเอง
          </Box>
        </Box>
        <img
          src={deleteBin}
          alt="Delete"
          onClick={() => removeQuiz(formId, index)}
          className={styles.modifyIcon}
          style={{
            width: '20px',
            height: '20px',
            marginTop: '23px'
          }}
        />
      </Box>
    </Box>
  )
}

function RatioField({ data, setData, formId, partName, index, removeQuiz }) {
  const scaleList = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"]
  const startName = data.forms[formId].forms[index].answer[0].name;
  const endName = data.forms[formId].forms[index].answer[1].name;
  const startScale = data.forms[formId].forms[index].answer[0].value
  const endScale = data.forms[formId].forms[index].answer[1].value;

  const handleChange = (idx, e) => {
    const updatedData = { ...data }; // Create a copy of the data object
    let quiz_answer = updatedData.forms[formId].forms[index].answer;

    // Update quiz_topic with the new value
    updatedData.forms[formId].forms[index].answer = quiz_answer.map((q, i) =>
      i === idx ? { ...q, value: e.target.value } : q
    );

    setData(updatedData)
  }

  return (
    <Box sx={{
      border: '1.4px solid #AEB4DD',
      borderRadius: 2,
      padding: 4,
      marginTop: '18px',
    }}>
      <Box sx={{
        marginTop: -1.5,
        display: 'flex',
        // alignItems: 'center',
        justifyContent: 'space-between',
      }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            flexDirection: 'row',
            marginTop: '23px',
            fontWeight: 600
          }}
        >ข้อที่ {index + 1}</Box>
        <Box width={'90%'}>
          <InsertBar
            currentValue={partName}
            setNewValue={(newPart) => {
              const updatedData = { ...data }; // Create a copy of the data object
              let quiz_topic = updatedData.forms[formId].forms;

              // Update quiz_topic with the new value
              updatedData.forms[formId].forms = quiz_topic.map((q, i) =>
                i === index ? { ...q, question: newPart } : q
              );

              setData(updatedData)
            }}
            placeholder="พิมพ์คำถามที่นี่"
          />
        </Box>
        <img
          src={deleteBin}
          alt="Delete"
          onClick={() => removeQuiz(formId, index)}
          className={styles.modifyIcon}
          style={{
            width: '20px',
            height: '20px',
            marginTop: '23px'
          }}
        />
      </Box>
      <Box
        sx={{
          gap: '15px',
          display: 'flex',
          alignItems: 'center',
        }}>
        <Box
          sx={{
            fontWeight: 600,
            width: '40px',
            marginRight: '20px'
          }}>
          สเกล
        </Box>
        <Select
          size="small"
          value={startScale || "null"}
          onChange={(e) => handleChange(0, e)}
          sx={{
            backgroundColor: '#C8EBEB',
            border: 'none',
            '.MuiOutlinedInput-notchedOutline': {
              borderColor: '#C8EBEB',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#C8EBEB',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: '#C8EBEB',
            },
            fontWeight: 600,
            color: '#478F96',
            fontSize: '14px',
            height: '50px',
            width: '86px',
          }}
        >
          <MenuItem value="null" disabled>
            เริ่มต้น
          </MenuItem>
          {scaleList.map((d) => (
            <MenuItem key={d} value={d}>
              {d}
            </MenuItem>
          ))}
        </Select>
        <Box>
          ถึง
        </Box>
        <Select
          size="small"
          value={endScale || "null"}
          onChange={(e) => handleChange(1, e)}
          sx={{
            backgroundColor: '#C8EBEB',
            border: 'none',
            '.MuiOutlinedInput-notchedOutline': {
              borderColor: '#C8EBEB',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#C8EBEB',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: '#C8EBEB',
            },
            fontWeight: 600,
            color: '#478F96',
            fontSize: '14px',
            height: '50px',
            width: '86px',
            display: 'flex', // Add flexbox
            alignItems: 'center', // Center content vertically
            justifyContent: 'center',
          }}
        >
          <MenuItem value="null" disabled>
            สิ้นสุด
          </MenuItem>
          {scaleList.map((d) => (
            <MenuItem key={d} value={d}>
              {d}
            </MenuItem>
          ))}
        </Select>
      </Box>
      <Box>
        <Box
          sx={{
            gap: '15px',
            display: 'flex',
            alignItems: 'center',
          }}>
          <Box
            sx={{
              fontWeight: 600,
              width: '40px'
            }}>
            เงื่อนไข
          </Box>
          <Box
            width={'30%'}
            paddingLeft={'20px'}>
            <InsertBar
              currentValue={startName}
              setNewValue={(newPart) => {
                const updatedData = { ...data }; // Create a copy of the data object
                let quiz_answer = updatedData.forms[formId].forms[index].answer;

                // Update quiz_topic with the new value
                updatedData.forms[formId].forms[index].answer = quiz_answer.map((q, i) =>
                  i === 0 ? { ...q, name: newPart } : q
                );

                setData(updatedData)
              }}
              placeholder="พิมพ์เงื่อนไขที่นี่"
            />
          </Box>
          <Box>
            ถึง
          </Box>
          <Box width={'30%'}>
            <InsertBar
              currentValue={endName}
              setNewValue={(newPart) => {
                const updatedData = { ...data }; // Create a copy of the data object
                let quiz_answer = updatedData.forms[formId].forms[index].answer;

                // Update quiz_topic with the new value
                updatedData.forms[formId].forms[index].answer = quiz_answer.map((q, i) =>
                  i === 1 ? { ...q, name: newPart } : q
                );

                setData(updatedData)
              }}
              placeholder="พิมพ์เงื่อนไขที่นี่"
            />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

function RatioPoint({ setData, formId, criteria, criIndex, removeCriteria }) {
  const scaleList = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];
  const startScale = criteria.score_from || "";
  const endScale = criteria.score_to || "";
  const title = criteria.recommend || "";
  const description = criteria.recommend_detail || "";

  return (
    <>
      <Box
        sx={{
          gap: '15px',
          display: 'flex',
          alignItems: 'center',
          width: '100%', // Ensure it takes full width
        }}
      >
        {/* "คะแนน" Label */}
        <Box
          className={styles.head2Text}
          sx={{
            fontWeight: 600,
            minWidth: '50px', // Adjust for better spacing
            marginRight: '10px',
          }}
        >
          คะแนน
        </Box>

        {/* Start Scale Select */}
        <Select
          size="small"
          value={startScale}
          onChange={(e) => {
            setData(prevData => {
              const updatedForms = [...prevData.forms];
              updatedForms[formId].interpret[criIndex] = {
                ...updatedForms[formId].interpret[criIndex],
                score_from: e.target.value
              };
              return { ...prevData, forms: updatedForms };
            });
          }}
          sx={{
            backgroundColor: '#C8EBEB',
            border: 'none',
            '.MuiOutlinedInput-notchedOutline': { borderColor: '#C8EBEB' },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#C8EBEB' },
            '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#C8EBEB' },
            fontWeight: 600,
            color: '#478F96',
            fontSize: '14px',
            height: '50px',
            width: '86px',
          }}
        >
          <MenuItem value="" disabled>เริ่มต้น</MenuItem>
          {scaleList.map((d) => (
            <MenuItem key={d} value={d}>{d}</MenuItem>
          ))}
        </Select>

        {/* "ถึง" Label */}
        <Box className={styles.head2Text}>ถึง</Box>

        {/* End Scale Select */}
        <Select
          size="small"
          value={endScale}
          onChange={(e) => {
            setData(prevData => {
              const updatedForms = [...prevData.forms];
              updatedForms[formId].interpret[criIndex] = {
                ...updatedForms[formId].interpret[criIndex],
                score_to: e.target.value
              };
              return { ...prevData, forms: updatedForms };
            });
          }}
          sx={{
            backgroundColor: '#C8EBEB',
            border: 'none',
            '.MuiOutlinedInput-notchedOutline': { borderColor: '#C8EBEB' },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#C8EBEB' },
            '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#C8EBEB' },
            fontWeight: 600,
            color: '#478F96',
            fontSize: '14px',
            height: '50px',
            width: '86px',
          }}
        >
          <MenuItem value="" disabled>สิ้นสุด</MenuItem>
          {scaleList.map((d) => (
            <MenuItem key={d} value={d}>{d}</MenuItem>
          ))}
        </Select>

        {/* "ข้อความแปลผล" and Input Field */}
        <Box
          className={styles.head2Text}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '15px',
            marginLeft: '20px',
          }}
        >
          <span>ข้อความแปลผล</span>
          <InsertBar
            currentValue={title}
            setNewValue={(newTitle) => {
              setData(prevData => {
                const updatedForms = [...prevData.forms];
                updatedForms[formId].interpret[criIndex] = {
                  ...updatedForms[formId].interpret[criIndex],
                  recommend: newTitle
                };
                return { ...prevData, forms: updatedForms };
              });
            }}
            placeholder="ข้อความแปลผล"
          />
        </Box>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 1 }}>
        <Box className={styles.head2Text}>
          คำแนะนำ/คำอธิบายเพิ่มเติม
        </Box>
        <img
          src={deleteBin}
          alt="Delete"
          onClick={() => removeCriteria(formId, criIndex)}
          className={styles.modifyIcon}
          style={{ width: '20px', height: '20px' }}
        />
      </Box>
      <Box sx={{ margin: "20px auto" }}>
        <TextField
          variant="outlined"
          fullWidth
          value={description}
          onChange={(e) => {
            setData(prevData => {
              const updatedForms = [...prevData.forms];
              updatedForms[formId].interpret[criIndex] = {
                ...updatedForms[formId].interpret[criIndex],
                recommend_detail: e.target.value
              };
              return { ...prevData, forms: updatedForms };
            });
          }}
          placeholder="อธิบายที่นี่..."
          multiline
          rows={6}
          sx={{
            '& .MuiOutlinedInput-root': {
              border: '1.4px solid #478F96',
              borderRadius: 2,
            },
            '& .MuiOutlinedInput-notchedOutline': {
              border: 'none', // Removes the default Material-UI border
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              border: '1.4px solid #478F96',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              border: '1.4px solid #478F96',
            },
          }}
        />
      </Box>
    </>
  );
}